import React from "react"
import style from "./index.module.scss"

const VideoFrame = ({ linkTo, onClickHandler }) => {
  return (
    <div className={style.frame_container}>
      <div className={style.icon_close} onClick={onClickHandler} />
      <iframe
        width="100%"
        height="100%"
        className={style.frame}
        src={linkTo}
        frameBorder="0"
        title="Як платити"
        allow="accelerometr; autoplay; encrypted-media; gyroscope; picture-in-picture"
      />
    </div>
  )
}

export default VideoFrame
